module.exports = __webpack_public_path__ + "static/media/027_concepts_nk_2-08.e4390143.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/027_concepts_nk_2-08.png
// module id = 525
// module chunks = 0